export default "__VITE_ASSET__1601066e__"